export const mapSickDayDto = (dto) => ({
    id: dto.id,
    userId: dto.userId,
    startDate: dto.startDate,
    endDate: dto.endDate,
    numberDays: dto.numberDays,
    displayName: dto.user.name,
});